﻿window.lcd = function () {

    var DELETE_TEXT = "Verwijderen";

    return {

        initialize: function (deletetext) {

            DELETE_TEXT = deletetext;

            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("LCD/Add");
            });

        },


        getAdditionalData: function () { },

        onDataBound: function (e) { },

        showItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.FullName;

            // Edit mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("LCD/Edit?userId=" + dataItem.UserID + "&breadcrumbLabel=" + label);
        },


        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Get DateItem
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Label
            var label = dataItem.FullName;

            // Edit mode Form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("LCD/Edit?userId=" + dataItem.UserID + "&breadcrumbLabel=" + label);
        },


        deleteItem: function (e) {

            var event = e;
            var data = this;

            function callbackYes(event, data) {
                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

                user.removeUser(dataItem.UserID);
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });

        },

        extraToolbarButton1_Clicked: function () {
            var url = 'LCD/ExportAllLCDUsersNodesDown';
            var filename = 'Export_LCDAll_' + fileDownload.getDateTimeString() + '.xlsx';
            var loaderId = 'extraToolbarButton1Loader';
            fileDownload.startDownload(appsettings.getUrl(url), filename, loaderId);
        },

        BSendNac_Clicked: function (userId) {
            var selectedNacId = $("#NacId").data("kendoDropDownList").value();

            $.ajax({
                type: "GET",
                url: appsettings.getUrl("LCD/Update_Provider_Nac") + "?userId=" + userId + "&nacId=" + selectedNacId,
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    }
                }
            });
        },

        BSendCancelLocation_Clicked: function (userId) {
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("LCD/Send_Cancel_Location") + "?userId=" + userId,
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {
                        main.openActionsDialog(' ', responseData.Message, [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    }
                }
            });
        },
    };

}();